
//vendors
import './App.css';
import { HashRouter, Routes, Route } from "react-router-dom";
//components
import Quiz from './components/quiz'
import NavBar from './components/navBar';
import Home from './components/home'
import Resources from './components/resources'
import Info from './components/info';
import Ml from './components/ml';

function App() {
  return (
    <HashRouter>
     <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/Quiz" element={<Quiz/>}/>
        <Route path="/Resources" element={<Resources/>}/>
        <Route path="/Info" element={<Info/>}/>
        <Route path="/ml" element={<Ml/>}/>
      </Routes>
    </HashRouter>
  );
}

export default App;
